var tableSort = {
	sorted: {
		ascending: "{field}: Sorted ascending. Click or tap to sort descending.",
		descending: "{field}: Sorted descending. Click or tap to sort ascending."
	},
	notSorted: {
		ascending: "{field}: Not sorted. Click or tap to sort ascending.",
		descending: "{field}: Not sorted. Click or tap to sort descending."
	}
};
var tableSortFr = {
	tableSort: tableSort
};

export { tableSortFr as default, tableSort };
